import * as Yup from 'yup';

const validation = Yup.object({
    email: Yup.string().required("Email Required").email("Invalid email address")
});

export default validation;
